module.exports = __webpack_public_path__ + "static/media/bg3.68273e12.ogg";